import { InviteLinkDto, TreeMemberDto } from '../services/api';

export const MEMBER_ROLE_ORDER: TreeMemberDto['role'][] = ['Viewer', 'Contributor', 'Editor', 'Manager', 'Owner'];

const MANAGEABLE_ROLES_BY_ACTOR: Record<TreeMemberDto['role'], TreeMemberDto['role'][]> = {
  Owner: ['Viewer', 'Contributor', 'Editor', 'Manager'],
  Manager: ['Viewer', 'Contributor', 'Editor'],
  Editor: [],
  Contributor: [],
  Viewer: [],
};

export const canManageMembership = (role?: string): role is TreeMemberDto['role'] => {
  return role === 'Owner' || role === 'Manager';
};

export const deriveCurrentUserTreeRole = (
  userId?: string,
  ownerId?: string,
  members?: TreeMemberDto[]
): TreeMemberDto['role'] | undefined => {
  if (!userId) {
    return undefined;
  }

  if (ownerId === userId) {
    return 'Owner';
  }

  return members?.find((member) => member.userId === userId)?.role;
};

export const getManageableRoleOptions = (
  actingRole?: TreeMemberDto['role'],
  targetRole?: TreeMemberDto['role'],
  isSelf = false
) => {
  if (!actingRole || !canManageMembership(actingRole) || isSelf || targetRole === 'Owner') {
    return [] as TreeMemberDto['role'][];
  }

  if (actingRole === 'Manager' && targetRole === 'Manager') {
    return [] as TreeMemberDto['role'][];
  }

  return MANAGEABLE_ROLES_BY_ACTOR[actingRole];
};

export const canRemoveMember = (
  actingRole?: TreeMemberDto['role'],
  targetRole?: TreeMemberDto['role'],
  isSelf = false
) => {
  return getManageableRoleOptions(actingRole, targetRole, isSelf).length > 0;
};

export type InviteStatus = 'Active' | 'Used' | 'Revoked' | 'Expired';

export const getInviteStatus = (invite: InviteLinkDto): InviteStatus => {
  if (invite.usedAt) {
    return 'Used';
  }

  if (invite.isRevoked) {
    return 'Revoked';
  }

  if (new Date(invite.expiresAt).getTime() <= Date.now()) {
    return 'Expired';
  }

  return 'Active';
};

export const getInviteStatusTone = (status: InviteStatus) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Used':
      return 'primary';
    case 'Revoked':
      return 'warning';
    case 'Expired':
    default:
      return 'default';
  }
};
